(() => {
  const root = document.querySelector('[data-creator-program]');
  if (!root) return;
  const form = root.querySelector('[data-creator-form]');
  const status = root.querySelector('[data-creator-status]');
  const result = root.querySelector('[data-creator-result]');
  const requestKey = crypto.randomUUID();
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const data = Object.fromEntries(new FormData(form));
    // A theme cannot issue or store real affiliate identities by itself.
    if (!root.dataset.endpoint) {
      status.textContent = 'Registration is temporarily unavailable. Please contact info@shappa.com.au.';
      return;
    }
    const button = form.querySelector('[type=submit]');
    button.disabled = true; status.textContent = 'Creating your referral…';
    try {
      const response = await fetch(root.dataset.endpoint, {method:'POST',headers:{'Content-Type':'application/json','Idempotency-Key':requestKey},body:JSON.stringify(data)});
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.error || 'Please try again.');
      root.querySelector('[data-referral-code]').value = payload.code;
      root.querySelector('[data-referral-link]').value = payload.link;
      root.querySelector('[data-test-referral]').href = payload.link;
      const heading = result.querySelector('h3');
      if (heading) heading.textContent = payload.state === 'pending' ? 'Your application is awaiting approval' : 'Your referral details';
      form.hidden = true; result.hidden = false; result.focus();
    } catch (error) { status.textContent = error.message || 'Unable to connect. Please try again.'; }
    finally { button.disabled = false; }
  });
  root.querySelectorAll('[data-copy]').forEach(button => button.addEventListener('click',async () => {
    const input = root.querySelector(`[data-referral-${button.dataset.copy}]`);
    try { await navigator.clipboard.writeText(input.value); root.querySelector('[data-copy-status]').textContent = 'Copied.'; }
    catch { input.focus(); input.select(); root.querySelector('[data-copy-status]').textContent = 'Select and copy the highlighted text.'; }
  }));
})();
